<template>
  <div>
    <img :src="logo" class="py-2 img-fluid" alt="..." />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "FootLogoComponent",
  components: {},

  props: {
    logo: {
      required: true,
      type: Object as PropType<string>,
    },
  },
});
</script>

<style scoped>
img {
  width: 90%;
  max-width: 250px !important;
}
</style>
